import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NormalizedFormState, NormalizedSection } from '../../store/config.models';
import { SectionType } from '../../store/models/models';;
import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectLocationCardReadOnly } from '../../store/selectors';

@Component({
    selector: 'app-dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.scss'],
})
export class DynamicFormComponent implements OnInit {
    @Input() formState$: Observable<NormalizedFormState>;
    @Input() form$: Observable<FormGroup>;

    actionsSection$: Observable<NormalizedSection>;
    contentSections$: Observable<NormalizedSection[]>;
    isReadOnly$: Observable<boolean>;

    constructor(private store: Store) {
        this.isReadOnly$ = this.store.select(selectLocationCardReadOnly);
    }

    ngOnInit(): void {
        this.actionsSection$ = this.formState$.pipe(map((v) => v.config.sections.find((v) => v.type === SectionType.Actions)));
        this.contentSections$ = this.formState$.pipe(map((v) => v.config.sections.filter((v) => v.type !== SectionType.Actions)));
    }
}
